import styled, { css } from 'styled-components';

interface IWrapperLayerSelect {
  id: string;
  opened: boolean;
  disabled: boolean;
}

interface IButton {
  label: string;
}

export const Wrapper = styled.div<IWrapperLayerSelect>`
  ${({ theme, id, opened }) => css`
    width: 100%;
    border-radius: ${theme.radius.xs};

    @media (max-width: 600px) {
      font-size: ${theme.font.sizes.sm};
    }

    @media (max-width: 400px) {
      font-size: ${theme.font.sizes.xs};
    }

    p {
      margin-bottom: 0;
      text-align: left;
      font-weight: ${theme.font.weights.regular};
    }

    #label_qtd_opened {
      border-radius: ${theme.radius.lg};
      background-color: #d2691e;
      color: #fff;
      font-size: ${theme.font.sizes.xs};
      font-weight: ${theme.font.weights.medium};
      margin-left: ${theme.spacings[4]};
      padding: ${theme.spacings[4]} ${theme.spacings[8]};
    }

    #label_new {
      border-radius: ${theme.radius.lg};
      background-color: #01c638;
      color: #fff;
      font-size: ${theme.font.sizes.xs};
      font-weight: ${theme.font.weights.medium};
      margin-left: ${theme.spacings[4]};
      padding: ${theme.spacings[2]} ${theme.spacings[8]};
    }

    ${opened && `#${id}{ font-weight: ${theme.font.weights.semiBold}}`}

    .selectLayer {
      width: 100%;
      padding: ${theme.spacings[4]} ${theme.spacings[8]};
      display: flex;
      align-items: center;
      border-radius: ${theme.radius.xs};
      cursor: pointer;

      svg {
        transition: all 0.2s;
        margin-right: ${theme.spacings[8]};
      }
    }

    @media (max-width: 400px) {
      .selectLayer {
        padding: ${theme.spacings[6]} 0 0 0;
      }

      #label_qtd_opened {
        font-size: ${theme.font.sizes.xxs};
        padding: ${theme.spacings[1]} ${theme.spacings[4]};
      }
    }
  `}
`;

export const Button = styled.div<IButton>`
  ${({ theme, label }) => css`
    position: relative;

    display: inline-flex;
    justify-content: center;

    border: 0;
    left: 10px;
    background-color: transparent;

    & + button {
      margin-right: ${theme.spacings[4]};
    }

    &:hover {
      &::before {
        top: ${label.includes(':') ? '-5rem' : '-3.5rem'};
        opacity: 1;
      }
    }

    &::before {
      content: '${label}';
      padding: ${theme.spacings[6]};
      position: absolute;
      top: -5rem;
      pointer-events: none;
      margin-right: ${label === 'Download' ? '30px' : '0px'};

      font-family: ${theme.font.family.default};
      font-size: ${theme.font.sizes.xs};
      font-weight: ${theme.font.weights.bold};

      border: 1px solid ${theme.colors.white};
      border-radius: 0.4rem;

      background-color: ${theme.colors.black};
      color: ${theme.colors.white};

      opacity: 0;
      transition: all 0.2s;
    }
  `}
`;

export const ContentLayer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    padding-left: ${theme.spacings[20]};
    // padding-right: ${theme.spacings[16]};

    @media (max-width: 400px) {
      padding-left: ${theme.spacings[16]};
    }
  `}
`;
